// Statsig log event naming standards
// https://eventbrite.atlassian.net/wiki/spaces/DEV/pages/15423275681/What+are+the+best+practice+naming+conventions+for+Heap+events#What-is-Eventbrite%E2%80%99s-Heap-naming-standard%3F
export const PAGE_VIEW = 'MLP - All - View - Page';
